export default from './menu';



// WEBPACK FOOTER //
// ./app/components/menu/index.js